"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEmail = void 0;
var email_validator_1 = require("email-validator");
function isValidEmail(email) {
    return (0, email_validator_1.validate)(email);
}
exports.isValidEmail = isValidEmail;
